import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Card, CheqLoader } from '@clickcease/cc-client-components-lib'
import { Timezones } from 'Assets/lists/timezones'
import { useGetUserInsights } from '../../api/getInsights'
import { getUnixTime } from 'date-fns'
import { InsightsTable } from 'Features/home/components/Insights/InsightsTable'
import { useGetDomains } from 'Features/domainsManagement/api/getDomains'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { Filters, TableRowTitle } from 'Features/home/routes/Home/types'
import { DEFAULT_TIME_ZONE, defaultFilters } from 'Features/home/routes/Home/utils'
import { InsightsWrapper, SmallTitle } from 'Features/home/routes/Home/Home.styled'
import { useGetUserProfile } from 'Features/userProfile/api/getUserProfile'

export const InsightsCard = () => {
  const { t } = useTranslation('dashboard')
  const { showToaster } = useAppStore()
  const [filters, setFilters] = useState<Filters>({ ...defaultFilters })
  const [insightsData, setInsightsData] = useState<TableRowTitle[]>([])

  const { data: domainsData } = useGetDomains()
  const { data: userQuery } = useGetUserProfile()

  const domainAddresses = domainsData
    ? domainsData.data.domains.map((domain) => domain.address)
    : []

  const selectedTimezone: string = useMemo(() => {
    if (userQuery) {
      return (
        Timezones.find((timezone) => timezone.value === userQuery.timezoneCountry)?.value ||
        DEFAULT_TIME_ZONE
      )
    }
    return DEFAULT_TIME_ZONE
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userQuery?.timezoneCountry])

  const { isFetching: isFetchingUserInsights, data } = useGetUserInsights({
    ...filters,
    domains: domainAddresses || [],
    timezone: selectedTimezone,
  })

  useEffect(() => {
    if (!isFetchingUserInsights) {
      const newData = !data ? [] : [...data.ips, ...insightsData]

      if (
        insightsData.length > 0 &&
        (newData.length === 0 || newData.length === insightsData.length)
      ) {
        showToaster(t('insights_table.insights_no_data_message'), 'info')
      }
      setInsightsData(newData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isFetchingUserInsights])

  return isFetchingUserInsights ? (
    <CheqLoader />
  ) : (
    <Card
      id={'home-insights-card'}
      title={t('insights')}
      headerUtilities={
        <>
          <SmallTitle>{t('show_data')}</SmallTitle>
          {insightsData.length > 0 && (
            <Button
              variant={'ghost'}
              text={t('load_more')}
              onClick={() => {
                setFilters({
                  ...defaultFilters,
                  startDate: defaultFilters.endDate,
                  endDate: getUnixTime(new Date()),
                })
              }}
            />
          )}
        </>
      }
    >
      <InsightsWrapper>
        <InsightsTable data={insightsData} />
      </InsightsWrapper>
    </Card>
  )
}
